import React from "react";
import { Helmet } from "react-helmet";

interface IProps {
  title: string;
  description: string;
  keywords: string;
}

const SEO: React.FC<IProps> = ({ title, description, keywords }) => {
  return (
    <Helmet>
      {/* Title Tag */}
      {title && <title>{title}</title>}

      {/* Meta Description Tag */}
      {description && <meta name="description" content={description} />}

      {/* Meta Keywords Tag */}
      {keywords && <meta name="keywords" content={keywords} />}
    </Helmet>
  );
};

export default SEO;
